function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 9.66732C17.5 14.2923 14.3 18.6173 10 19.6673C5.7 18.6173 2.5 14.2923 2.5 9.66732V4.66732L10 1.33398L17.5 4.66732V9.66732ZM10 18.0006C13.125 17.1673 15.8333 13.4507 15.8333 9.85065V5.75065L10 3.15065L4.16667 5.75065V9.85065C4.16667 13.4507 6.875 17.1673 10 18.0006Z",
  className: "icon-primary"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.58317 13.4167L13.7498 9.25L12.4998 8L9.58317 10.9167L7.9165 9.25L6.6665 10.5L9.58317 13.4167Z",
  className: "icon-primary"
});

function SvgKycApprovedShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    className: "icon-secondary",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycApprovedShort);
export default __webpack_public_path__ + "static/media/kyc-approved-short.c635c936.svg";
export { ForwardRef as ReactComponent };